import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LogoComponent } from './logo/logo.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import { AddressSelectorComponent } from './address-selector/address-selector.component';



@NgModule({
  declarations: [
    LogoComponent,
    SearchBoxComponent,
    AddressSelectorComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    LogoComponent,
    SearchBoxComponent,
    AddressSelectorComponent
  ]
})
export class UiModule { }
